/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const OfferRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.OFFER.PACKAGES.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/offer/offer/offer.module').then(m => m.OfferPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.OFFER.RECOMMENDATIONS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/offer/recommendations/recommendations.module').then(m => m.RecommendationsPageModule),
    canActivate: [NavigationGuard],
  },
];
